var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipEmailSubsection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5H2C1.73333 3.5 1.48 3.60667 1.29333 3.79333C1.10667 3.98 1 4.23333 1 4.5V12.5C1 12.7667 1.10667 13.02 1.29333 13.2067C1.48 13.3933 1.73333 13.5 2 13.5H14C14.2667 13.5 14.52 13.3933 14.7067 13.2067C14.8933 13.02 15 12.7667 15 12.5V4.5C15 4.23333 14.8933 3.98 14.7067 3.79333C14.52 3.60667 14.2667 3.5 14 3.5ZM12.9 4.5L8 7.89333L3.1 4.5H12.9ZM2 12.5V4.95333L7.71333 8.90667C7.8 8.96667 7.89333 8.99333 8 8.99333C8.10667 8.99333 8.2 8.96 8.28667 8.90667L14 4.95333V12.5H2Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipEmailSubsection);
export default __webpack_public_path__ + "static/media/ic-chip-email-subsection.8e2cf86fa2b0808366f50cfad1d31046.svg";
export { ForwardRef as ReactComponent };